<template>
    <v-container class="fill-height" fluid>
      <v-row justify="center" align="center">
        <v-col cols="12" sm="8" md="6" lg="4">
          <v-card class="pa-6 rounded-xl" elevation="2">
            <div class="text-center mb-6">
              <v-icon size="64" color="primary">mdi-shield-lock</v-icon>
              <h2 class="text-h4 mt-4">Verify Your Account</h2>
              <p class="text-body-1 mt-2">
                We've sent a 6-digit code to {{ maskedContact }}
              </p>
            </div>
  
            <!-- OTP Input Field -->
            <v-otp-input
              v-model="otpCode"
              input-mode="numeric"
              :length="6"
              type="number"
              variant="outlined"
              density="comfortable"
              :loading="verifying"
              @finish="handleVerify"
            ></v-otp-input>
  
            <!-- Countdown and Resend -->
            <div class="text-center mt-4">
              <p v-if="timeLeft > 0" class="text-body-2">
                Resend code in {{ formattedTime }}
              </p>
              <v-btn
                variant="text"
                color="primary"
                @click="resendOtp"
                :loading="resending"
              >
                Resend OTP
              </v-btn>
            </div>
  
            <v-btn
              block
              color="primary"
              size="large"
              class="mt-6"
              @click="handleVerify"
              :disabled="otpCode.length !== 7"
              :loading="verifying"
            >
              Verify OTP
            </v-btn>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script setup>
  import { ref, computed, onMounted } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import { verifyOtp, ResendOtp } from '@/services/apiServices.js'
  
  const route = useRoute()
  const router = useRouter()
  
  // OTP Field
  const otpCode = ref('')
  const verifying = ref(false)
  const contact = ref(route.query.contact || '')
  
  // Masked contact display
  const maskedContact = computed(() => {
    if (!contact.value) return 'your contact'
    return contact.value.includes('@') 
      ? `${contact.value[0]}***@${contact.value.split('@')[1]}`
      : `${contact.value.slice(0, 3)}****${contact.value.slice(-3)}`
  })
  
  // Timer
  const timeLeft = ref(0)
  const formattedTime = computed(() => {
    const mins = Math.floor(timeLeft.value / 60)
    const secs = timeLeft.value % 60
    return `${mins}:${secs.toString().padStart(2, '0')}`
  })
  
  // Verification handler
  const handleVerify = async () => {
    if (otpCode.value.length !== 6) return
    
    verifying.value = true
    try {
      const response = await verifyOtp({
        otp: otpCode.value,
        contact: contact.value
      })
      if (response.success) {
        router.push('/authentication/login')
      }
    } finally {
      verifying.value = false
    }
  }
  const resendOtp = async () => {
    // console.log('Resending OTP...')
    verifying.value = true
    try {
        // console.log('Resending OTP...')
        const response = await ResendOtp({
        // otp: otpCode.value,
        contact: contact.value
      })
      
      if (response.success) {
        router.push('/authentication/login')
      }
    } finally {
      verifying.value = false
    }
  }
  </script>
  
  <style scoped>
  .v-otp-input {
    justify-content: center;
    gap: 12px;
  }
  
  .v-otp-input :deep(.v-field) {
    font-size: 1.25rem;
    height: 52px;
    width: 52px !important;
  }
  </style>